import { render, staticRenderFns } from "./Page5.vue?vue&type=template&id=59155dd4&scoped=true&"
import script from "./Page5.vue?vue&type=script&lang=js&"
export * from "./Page5.vue?vue&type=script&lang=js&"
import style0 from "./Page5.vue?vue&type=style&index=0&id=59155dd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59155dd4",
  null
  
)

export default component.exports